export enum ErrorPresentModes  {
    GENERIC_TO_USER,
    DETAILS_TO_USER
}

export enum ErrorSeverities  {
    UNRECOVERABLE = 'UNRECOVERABLE',
    RECOVERABLE = 'RECOVERABLE'
}

export class CustomError extends Error {

    protected presentMode:ErrorPresentModes = ErrorPresentModes.GENERIC_TO_USER;
    protected severity:ErrorSeverities = ErrorSeverities.UNRECOVERABLE;

    /**
     * Transforms a generic Error to a typed CustomError
     * while returns any CustomError and sub types as is.
     * @param e
     * @param cb
     */
    static ensureTyped(e:Error,cb?:(e:CustomError)=>void):CustomError | void{
        const ce = e['getSeverity'] ? <CustomError>e : new CustomError(e.message);
        if(!cb) return ce;
        else cb(ce);
    }

    getPresentMode():ErrorPresentModes{
        return this.presentMode;
    }

    getSeverity():ErrorSeverities{
        return this.severity;
    }

    constructor(message) {
        super(message ? message : 'Error occurred. [err: CUSTOM]');
        this.name = 'CustomError';
    }
}